import React from 'react'
import styled from 'styled-components'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'

import { friendlyName } from 'helpers/formatters'

import { color } from 'styles/colors'

type Props = {
  group: {
    label: string;
    filters: string[];
    groupPosition: string;
  }
  selectedFilters: string[];
  toggleFilterCallback: (arg1: { label: string, filters: string[] }, arg2: string, arg3: boolean) => void;
}

function FilterButton ({ group, selectedFilters, toggleFilterCallback }: Props) {
  return (
    <>
      {group.filters.map(filter => {
        const isSelected = selectedFilters.includes(filter)

        return (
          <S.FilterButton
            key={filter}
            disableRipple
            className={isSelected ? 'selected filter ' + filter : 'filter ' + filter}
            onClick={() => { toggleFilterCallback(group, filter, isSelected) }}
          >
            {isSelected && <S.CheckIcon />}
            {friendlyName(filter)}
          </S.FilterButton>
        )
      })}
    </>
  )
}

const FilterGroup = ({ group, selectedFilters, toggleFilterCallback }: Props) => {
  return (
    <S.FilterGroup key={group.label + '-' + group.filters[0]} groupPosition={group.groupPosition}>
      <S.Label>{friendlyName(group.label)}</S.Label>
      <S.Filters>
        <FilterButton {...{ group, selectedFilters, toggleFilterCallback }} />
      </S.Filters>
    </S.FilterGroup>
  )
}

export default FilterGroup

const S = {
  CheckIcon: styled(CheckIcon)`
    font-size: 25px;
    margin-right: 5px;
    margin-left: -5px;
  `,
  FilterButton: styled(Button)`
    font-family: "Inter", sans-serif;
    font-size: 14px;
    color: ${color('customerFilterText')};
    border: 1px solid ${color('customerFilterBorder')};
    border-radius: 25px;
    cursor: pointer;
    transaition: background-color 0.3s, color 0.3s;
    padding: 10px 20px;
    margin: 5px;
    text-transform: capitalize;

    &:hover, &:focus {
      border: 1px solid ${color('customerFilterHoverBorder')} !important;
      background-color: ${color('customerFilterHoverBackground')};
    }

    &.selected{
      font-weight: 900;
      color: ${color('customerFilterSelected')};
      background-color: ${color('customerFilterSelectedBackground')};
      border: 1px solid ${color('customerFilterSelectedBorder')} ;
    }
  `,
  FilterGroup: styled.div.withConfig({
    shouldForwardProp: (prop) => !['groupPosition'].includes(prop)
  })<{ groupPosition: string }>`
    display: flex;
    flex-direction: column;
    background-color: ${color('customerFilterGroup')};
    border: 1px solid ${color('customerFilterGroup')};
    border-radius: 15px;
    margin: 8px;

    ${({ groupPosition }) => groupPosition === 'L' && `
      padding: 8px 0px;
    `}
  `,
  Label: styled.div`
    color: ${color('customerFilterText')};
    padding-left: 15px;
    text-align: justify;
    width: 100px;
  `,
  Filters: styled.div`
    display: inline;
    white-space: normal;
    margin: 5px;
  `
}
